import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChartCardsComponent } from './chart-cards.component';

@NgModule({
  declarations: [ChartCardsComponent],
  exports: [ChartCardsComponent],
  imports: [
    CommonModule
  ]
})
export class ChartCardsModule { }
